import { render, staticRenderFns } from "./RecentCollection.vue?vue&type=template&id=d5fb6998&scoped=true&"
import script from "./RecentCollection.vue?vue&type=script&lang=js&"
export * from "./RecentCollection.vue?vue&type=script&lang=js&"
import style0 from "./RecentCollection.vue?vue&type=style&index=0&id=d5fb6998&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5fb6998",
  null
  
)

export default component.exports